function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.666 4.99897C5.56114 4.96297 8.34481 3.87743 10.5 1.94397C12.655 3.87779 15.4387 4.9637 18.334 4.99997C18.444 5.64997 18.5 6.31997 18.5 7.00097C18.5 12.226 15.16 16.671 10.5 18.318C5.84 16.67 2.5 12.225 2.5 6.99997C2.5 6.31797 2.557 5.64997 2.666 4.99897ZM14.207 8.70697C14.3892 8.51837 14.49 8.26577 14.4877 8.00357C14.4854 7.74137 14.3802 7.49056 14.1948 7.30515C14.0094 7.11974 13.7586 7.01457 13.4964 7.0123C13.2342 7.01002 12.9816 7.11081 12.793 7.29297L9.5 10.586L8.207 9.29297C8.0184 9.11081 7.7658 9.01002 7.5036 9.0123C7.2414 9.01457 6.99059 9.11974 6.80518 9.30515C6.61977 9.49056 6.5146 9.74137 6.51233 10.0036C6.51005 10.2658 6.61084 10.5184 6.793 10.707L8.793 12.707C8.98053 12.8944 9.23484 12.9998 9.5 12.9998C9.76516 12.9998 10.0195 12.8944 10.207 12.707L14.207 8.70697Z",
  fill: "#22C55E"
});

function SvgSecureShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureShield);
export default __webpack_public_path__ + "static/media/secure-shield.87df8a82.svg";
export { ForwardRef as ReactComponent };